// extracted by mini-css-extract-plugin
export default {"container":"MainSectionSkills_container__BtJpU","skillsContainer":"MainSectionSkills_skillsContainer__aBXr-"};